export function resolveValue(valueOrCallback) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    return typeof valueOrCallback === "function"
        ? (_a = valueOrCallback).call.apply(_a, [null].concat(args)) : valueOrCallback;
    var _a;
}
export default resolveValue;

//# sourceMappingURL=resolveValue.js.map



//////////////////
// WEBPACK FOOTER
// ./node_modules/reassemble/lib/utils/resolveValue.js
// module id = 17
// module chunks = 0